import gql from "graphql-tag";

export default gql`
  mutation AdminUpdateVenue(
    $id: Int!
    $name: String!
    $administratorName: String
    $phone: String
    $email: String
    $venueAddress: JSON
    $latitude: Float!
    $longitude: Float!
    $OrganizationId: Int!
    $countryCode: String!
  ) {
    admin_updateVenue(
      id: $id
      name: $name
      administratorName: $administratorName
      phone: $phone
      email: $email
      venueAddress: $venueAddress
      latitude: $latitude
      longitude: $longitude
      OrganizationId: $OrganizationId
      countryCode: $countryCode
    ) {
      id
    }
  }
`;
